var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      enableBackground: "new 0 0 405.4 251.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE6E5"
    },
    d: "M347,73.9c-0.4-0.3-1-0.7-1.9-0.8c-0.5-0.1-0.9-0.1-1.3-0.1c0.4-2.4,0-3.1-0.3-3.3 c-2.1-1.1-7.9,13.5-20.2,19.5c-6.3,3-12.6,3-17.1,2.5c-0.5,1.7-1,3.4-1.5,5c3.7,2.2,10.5,5.4,18.9,4.9c14.2-0.8,27.1-11.8,32.9-27.8 C353.4,73.9,350.2,73.9,347,73.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.1,
    y1: -878.6935,
    x2: 314.5,
    y2: -878.6935,
    gradientTransform: "matrix(1 0 0 -1 0 -758.8935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M303.8,17.6h-267c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272 c3.1,0,5.7-2.5,5.7-5.7V28.2C314.3,22.4,309.6,17.6,303.8,17.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "298.9,45.7 40.4,45.7 40.4,45.7 40.4,32.9 298.9,32.9 298.9,32.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0D4FF"
    },
    d: "M40.4,55v150.2c0,1.6,1.3,3,3,3h252.5c1.6,0,3-1.3,3-3V56.4c0-0.7-0.6-1.3-1.3-1.3L40.4,55 L40.4,55z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M293,39.3c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S293,37.6,293,39.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077312492483393740370000002001898170829747092_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4,
    y1: -989.3435,
    x2: 330.2,
    y2: -989.3435,
    gradientTransform: "matrix(1 0 0 -1 0 -758.8935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077312492483393740370000002001898170829747092_)"
    },
    d: "M324.5,222H16.2c-3.2,0-5.8,2.5-5.8,5.7 v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C330.2,224.5,327.7,222,324.5,222z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181790135638501910660000004673977585526688917_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.2,
    y1: 1188.4542,
    x2: 341.6,
    y2: 1115.054,
    gradientTransform: "matrix(1 0 0 1 0 -1021.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 63,
    style: {
      fill: "url(#SVGID_00000181790135638501910660000004673977585526688917_)"
    },
    width: 11.8,
    height: 135
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.1,50.1c0,1.8-1.5,3-3,3v-0.3c0-0.3,0-0.6,0-0.6c0-0.6,0-1.8,0-2.1 C325,50.1,325.9,50.1,327.1,50.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 167.1,
    transform: "matrix(0.9999 -1.008818e-02 1.008818e-02 0.9999 -1.7059 1.6993)",
    style: {
      fill: "#FFFFFF"
    },
    width: 73.2,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 179.2,
    transform: "matrix(0.9999 -1.008818e-02 1.008818e-02 0.9999 -1.8279 1.701)",
    style: {
      fill: "#FFFFFF"
    },
    width: 73.2,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M383.6,34.7c0.2-0.6,0.2-1.1,0.1-1.4c-0.1-1.1-0.5-4-1.2-8c-0.1-0.3-0.4-0.4-0.7-0.4 c-0.3,0-0.6,0.2-0.7,0.5c0.1,1.1,0.2,2.2,0.4,3.3c-0.2-1.2-0.4-2.4-0.6-3.5c-0.1-0.5-0.5-0.8-0.9-0.7c-0.3,0.1-0.6,0.4-0.6,0.8 c0.1,1.2,0.2,2.4,0.3,3.6c-0.3-1.2-0.6-2.5-0.8-3.7c-0.1-0.5-0.6-0.7-1-0.6c-0.3,0.1-0.6,0.5-0.5,0.9c0.2,1.3,0.3,2.5,0.5,3.8 c-0.4-1.2-0.7-2.4-1.1-3.7c-0.1-0.4-0.5-0.6-0.8-0.5c-0.4,0.1-0.6,0.5-0.5,0.9c0.5,2.2,0.9,4.5,1.4,6.7l2,3.8 c0.1,0.8,0.2,1.5,0.3,2.3c1.4-0.4,2.7-0.8,4.1-1.2c-0.2-0.6-0.3-1.2-0.4-1.8C383.1,35.7,383.4,35.3,383.6,34.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146499092705428291960000010747801330514219918_",
    gradientUnits: "userSpaceOnUse",
    x1: -6872.0781,
    y1: 763.6395,
    x2: -6809.209,
    y2: 763.6395,
    gradientTransform: "matrix(1 0 0 1 7205.9556 -688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191519"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#312B30"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146499092705428291960000010747801330514219918_)"
    },
    d: "M340.3,71.3c-1.8-2.2-6.8-8.8-6.4-17.6 c0.1-1.7,0.2-5.2,2.2-8.9c0.7-1.4,2.9-5.4,7.3-7.5c6-2.9,13.4-1,18.2,3.1c6.3,5.4,6.4,13.3,6.4,14.5c9.1-4,18.5,0,21,6.4 c1.6,4.3,0.1,9.6-3.4,13.7c9.9,4.7,13.6,16,9.5,24c-3.2,6.2-10.8,9.9-18.7,8.7c-1,1.7-3.7,6-8.7,7.3c-6.5,1.7-12.2-2.8-15.1-5 C338.3,98.7,340,75.2,340.3,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M383.6,36.5c-1.7,0.5-3.3,1-5,1.5c-1.2,9-4.5,15.3-6.6,18.7c-2.7,4.3-5.6,8.2-10.2,9.8 c-3.2,1.1-6.6,1-6.6,1c-0.3,0-0.6,0-0.9,0c-4.1-0.1-7.9,0.3-11.4,1.1c-1.4,3-2.3,5.5-3,7.6c-0.3,0.9-1.3,3.9-1.3,6.7 c0,0.4,0,0.6,0,0.7c0.1,2,0.8,3.6,1.3,4.6c0.3,2.5,0.5,5.9-0.1,9.8c-0.3,2.1-0.8,4-1.4,5.6c2.4,1.3,6.7,3.3,12.5,3.7 c5.2,0.4,9.4-0.7,11.9-1.5c-0.5-1.9-1-4.2-1.3-6.9c-0.4-4,0-7.5,0.5-10.1c0.6-2.4,1.2-4.7,1.8-7.1c1.9-0.6,14.9-5.1,20.5-19.1 C389.4,49.7,384.5,38.4,383.6,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M343.8,63.9c0.2,1.6,0.5,3.3,0.7,4.9c-0.1,0.3-0.1,0.6,0,1c0.4,1.1,2.5,1.1,3.2,1.2 c3.1,0.1,5.7-1.9,7-3.1c-0.8-1-1.7-2.6-2.4-4.6c-0.9-2.6-0.9-4.9-0.9-6.4c-1.6-0.8-3.3-1.6-4.9-2.3 C345.7,57.6,344.8,60.7,343.8,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M343.8,63.9c0.1-0.4,0.3-0.9,0.4-1.3c2-1.2,4.1-2.4,6.1-3.5l0,0c0.2,0.3,0.5,0.7,0.7,1.1 c0.2,0.4,0.3,0.8,0.4,1.1c-0.2,0.7-0.6,2-1.7,3.2c-1.9,2.1-4.5,2.4-5.4,2.4C344.1,65.8,344,64.9,343.8,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M341.7,46.2c-2.1,1.6-2.5,15.5-1.8,17.3c0.7,1.8,4.2,1.4,6.4,1.3c2.2-0.1,4.8-2,5.4-2.7 c0.5-0.7,0.1-3.3,0.1-3.3s1.9,1,2.1-0.8s-1-4.5-1.6-3.5c-0.7,1-0.7,1-0.7,1S344,44.5,341.7,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE6E5"
    },
    d: "M349.4,70.7c-0.9,0-1.8,0-2.6,0.1c-0.5,1.7-1.1,4.2-1.5,7.2c-0.3,2.9-0.3,5.1-0.2,9.3 c0.1,5.5,0.4,5.9,0.3,8.8c0,2.5-0.3,6.1-1.3,10.5c0.5,0.1,1,0.2,1.6,0.3c0.5,0.1,1.1,0.1,1.7,0.2c0.4-3.6,0.6-6.8,0.7-9.7 c0.1-2.1,0-3.8-0.1-7.2c-0.2-7.2-0.4-8-0.2-10.6C347.9,77.4,348.3,74.4,349.4,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M348.3,70.7c-0.9,0-1.8,0-2.6,0.1c-0.5,1.7-1.1,4.2-1.5,7.2c-0.3,2.9-0.3,5.1-0.2,9.3 c0.1,5.5,0.4,5.9,0.3,8.8c0,2.5-0.3,6.1-1.3,10.5c0.5,0.1,1,0.2,1.6,0.3c0.5,0.1,1.1,0.1,1.7,0.2c0.4-3.6,0.6-6.8,0.7-9.7 c0.1-2.1,0-3.8-0.1-7.2c-0.2-7.2-0.4-8-0.2-10.6C346.8,77.4,347.1,74.4,348.3,70.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAE6E5"
    },
    points: "342.1,69 344.7,75.5 345.9,72.7 347.1,75.5 356.5,67.8 346,70.6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.3,68.1c0.6,0.9,1.2,1.7,1.8,2.6c-0.6,0.9-1.2,1.8-1.9,2.7c-0.8-1.7-1.5-3.3-2.3-5 C342.7,68.3,343.5,68.2,344.3,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M346,70.6c0.5,1,1,1.9,1.5,2.9c3.3-2.1,6.5-4.2,9.8-6.3c-1.1-0.5-2.3-0.9-3.4-1.4 C351.2,67.5,348.6,69,346,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M355.9,175c3.4-20.9,6.7-41.8,10.1-62.6c-8.7-0.9-17.4-1.8-26.1-2.7c0.1,15.7-1.9,27.4-3.9,35.5 c-1.2,4.6-1.7,8.5-1.9,11.4c-0.3,4.6-0.6,8.3,0.8,12.9c0.5,1.3,1.3,3.3,2.4,5.6c2.2,4.5,5.9,10.6,17.7,22.6 c4.8,4.9,4.7,4.4,10.6,10.3c6.1,6.1,10.8,11.2,13.9,14.6c1.5-1.7,3-3.4,4.6-5C374.6,203.4,365.3,189.2,355.9,175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M363.6,115.1c-0.4-0.3-5.6-4.5-5.6-4.5l0,0c-2.5-1.5-5.8-3-10-4c-1.3,13.8-1.5,25-1.5,32.5 c0.1,17.4,1.6,28.5,4.7,61.4c1.2,13,2.1,23.5,2.7,30.1c2.2,0.2,4.5,0.4,6.7,0.6c3.1-28.4,6.2-56.8,9.3-85.2 C369.2,123.8,366.1,117.2,363.6,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M380.4,229.7c3-2.6,3.5-12.6,3.5-12.6s3.7,1.2,4.1,3.1c0.4,1.9-7.1,17.5-9.6,17.4 c-1.1,0-1.2-3.1-0.9-6.5C378.2,231.1,379.1,230.8,380.4,229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M348,234.6c3.7,1.4,12.8-2.9,12.8-2.9s0.7,3.8-0.8,5.1s-18.7,2.1-19.9-0.2c-0.5-1,2.2-2.5,5.3-3.9 C345.8,233.3,346.5,234,348,234.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000907086199350478840000011253896738970782344_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.4117,
    y1: 820.05,
    x2: 371.5487,
    y2: 820.05,
    gradientTransform: "matrix(1 0 0 1 0 -688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2593,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7759,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000907086199350478840000011253896738970782344_)"
    },
    d: "M338.2,102.8c2.7,1,7.4,2.2,13.2,1.8 c4.6-0.3,8.2-1.5,10.6-2.5c3.2,6.3,7.6,16.6,9,30.1c1.4,12.7-0.4,23.1-2,29.8c-12.1-0.1-24.2-0.2-36.3-0.4c-0.5-8.8-0.4-19,0.7-30.4 C334.4,120.6,336.2,111,338.2,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M377,219.5c0.7,0.8,1.3,1.7,2,2.5c-0.1,1.1-0.2,2.3-0.4,3.5c-0.3,2.1-0.6,4-1,5.8 c0.7,0,1.7-0.3,2.9-1.4c4.7-4.1,3.6-12.1,3.5-12.7c-0.7-0.6-1.4-1.2-2-1.8c-0.9-0.9-1.8-1.8-2.5-2.6 C378.6,215.1,377.8,217.3,377,219.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M354.2,229.8c-1,0.5-2.1,0.9-3.3,1.4c-2,0.8-3.8,1.4-5.6,1.9c0.3,0.6,1.1,1.3,2.6,1.9 c5.9,2.2,12.4-2.6,12.8-3c0.2-1.6,0.4-3.6,0.6-6l-7.4,1.1C354,228,354.1,228.9,354.2,229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M375.8,30.5c-0.2-0.3-0.5-0.5-0.8-0.5c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.3-0.1,0.8,0,1.1 c0.6,1.9,1.1,2.8,1.1,2.8c0.6,1.3,0.8,1.7,1,1.9c0.1,0.1,0.1,0.1,0.2,0.1c0.7,0.5,1.5,0.5,2.2,0.5l-2-3.8 C376.5,32,376.1,31.3,375.8,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344,59.3h-4.5c0,0.7,0,1.4,0.1,1.9c0.5,0.4,1.1,0.7,1.8,0.7C342.9,61.9,344.1,60.7,344,59.3 C344.1,59.3,344,59.3,344,59.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2E5EA0"
    },
    cx: 168.9,
    cy: 74.6,
    rx: 67.3,
    ry: 67.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151.1,87.9c-5.6-4.9-9.4-12.2-9.4-20.3c-0.2-15,11.8-27.2,26.8-27.4S195.7,52,195.9,67 c0.2,8.1-3.4,15.4-8.8,20.4c13.5,6.6,22.9,20.3,23.3,36.2c0,1.5,0,2.8-0.2,4.3c-11.3,8.6-25.1,13.9-40.3,14.1s-29.3-4.7-40.7-12.9 c-0.2-1.5-0.2-2.8-0.4-4.3C128.8,108.7,137.8,94.7,151.1,87.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M225,110.7l-13.2,32.6c6.3,0,12.4-3.2,15.9-8.7l52.6,21.2c3.2-3.1,2.4-6.8,2.4-6.8l-52.3-21.1 C231.7,121.6,229.6,115.1,225,110.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3A3A3"
    },
    d: "M194.2,117.2c-3.9,9.7,0.8,20.8,10.5,24.7c2.3,0.9,4.8,1.4,7.2,1.4l13.2-32.6 c-1.7-1.7-3.8-3-6.1-4C209.2,102.8,198.1,107.5,194.2,117.2z M201.6,120.2c0.9-2.2,3.4-3.2,5.6-2.4c2.2,0.9,3.2,3.4,2.4,5.6 c-0.9,2.2-3.4,3.2-5.6,2.4C201.8,124.9,200.7,122.4,201.6,120.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.5,
    y: 155.9,
    transform: "matrix(0.374 -0.9274 0.9274 0.374 27.2769 354.3799)",
    style: {
      fill: "#A3A3A3"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 153.2,
    transform: "matrix(0.374 -0.9274 0.9274 0.374 25.5684 346.4762)",
    style: {
      fill: "#A3A3A3"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 260.1,
    y: 150.5,
    transform: "matrix(0.374 -0.9274 0.9274 0.374 23.8605 338.5726)",
    style: {
      fill: "#A3A3A3"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 211.9,
    y1: 143.3,
    x2: 211.9,
    y2: 143.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M226.2,116.1l-21.9,27.5c6.1,1.8,12.8,0.4,17.7-3.8l44.5,35.3c4-2,4.2-5.9,4.2-5.9l-44.2-35.1 C229.4,128.4,229.3,121.6,226.2,116.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M194.7,113.6c-6.5,8.2-5.1,20.2,3.1,26.7c2,1.6,4.2,2.7,6.5,3.3l21.9-27.5c-1.2-2.1-2.7-4-4.7-5.5 C213.2,104,201.3,105.4,194.7,113.6z M201,118.6c1.5-1.8,4.2-2.2,6-0.7s2.2,4.2,0.7,6s-4.2,2.2-6,0.7S199.6,120.5,201,118.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.4,
    y: 173.9,
    transform: "matrix(0.6218 -0.7832 0.7832 0.6218 -37.9215 271.4139)",
    style: {
      fill: "#CCCCCC"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.7,
    y: 169.4,
    transform: "matrix(0.6218 -0.7832 0.7832 0.6218 -36.5848 265.2294)",
    style: {
      fill: "#CCCCCC"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 248.1,
    y: 165,
    transform: "matrix(0.6218 -0.7832 0.7832 0.6218 -35.2388 259.2399)",
    style: {
      fill: "#CCCCCC"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 204.3,
    y1: 143.7,
    x2: 204.3,
    y2: 143.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEDED"
    },
    d: "M226.4,124.2l-29.6,19.1c5.2,3.6,12,4.5,18,2.1l30.8,47.7c4.4-0.7,5.9-4.2,5.9-4.2l-30.6-47.4 C225.5,136.9,227.5,130.4,226.4,124.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEDED"
    },
    d: "M197.4,111.7c-8.8,5.7-11.3,17.4-5.7,26.2c1.4,2.1,3.1,3.9,5.1,5.2l29.6-19.1 c-0.4-2.3-1.3-4.6-2.7-6.8C218,108.6,206.2,106,197.4,111.7z M201.8,118.5c2-1.3,4.6-0.7,5.9,1.3c1.3,2,0.7,4.6-1.3,5.9 s-4.6,0.7-5.9-1.3C199.2,122.4,199.8,119.7,201.8,118.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238.8,
    y: 190.4,
    transform: "matrix(0.8403 -0.5422 0.5422 0.8403 -65.2632 161.5103)",
    style: {
      fill: "#EFEDED"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.9,
    y: 184.3,
    transform: "matrix(0.8403 -0.5422 0.5422 0.8403 -62.5726 158.4167)",
    style: {
      fill: "#EFEDED"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 178.3,
    transform: "matrix(0.8403 -0.5422 0.5422 0.8403 -59.948 155.3528)",
    style: {
      fill: "#EFEDED"
    },
    width: 5.3,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 196.8,
    y1: 143.2,
    x2: 196.8,
    y2: 143.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.c22a4302.svg";
export { ForwardRef as ReactComponent };